import styled from 'styled-components';

export const Thead = styled.thead`
  background: #f2f2f2;
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
  padding: 8px;
  line-height: normal;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Th = styled.th`
  text-align: center;
  background: #4b286d;
  color: #fff;
  font-weight: 700;
  padding: 8px;
  line-height: normal;
`;

export const ServiceNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const CheckboxLabel = styled.p`
  font-size: 13px;
  color: #565656;
  font-weight: 700;
  letter-spacing: 0.15px;
`;
